<template>
</template>
<script>
    import API from '@/api';
    import { loading } from '@/utils';

    export default {
        mounted() {
            this.fetchUser();
        },
        methods: {
            fetchUser: async function () {
                let service = loading();
                try {
                    service.load();
                    const tokenId = _.get(this.$router, 'currentRoute.query.tokenId');

                    const redirectUrl = JSON.parse(sessionStorage.getItem('redirectUrl'));

                    sessionStorage.setItem('JSESSIONID', tokenId);
                    localStorage.setItem('JSESSIONID', tokenId);

                    const {data, code, errDetails} = await API.common.KPMGLogin();
                    if (code === '1') {
                        let locale = localStorage.getItem('lang')
                        if(!locale || locale == '' || locale == null){
                            this.$i18n.locale = 'zh'
                            localStorage.setItem('lang', 'zh')
                        } else {
                            this.$i18n.locale = localStorage.getItem('lang')
                        }
                        //自动登陆成功,设置角色菜单 等等
                        this.$store.commit('common/setUser', data);
                        service.close();

                        if (data.userType === '1' && data.isSecurityAuditor) {
                          // 安全管理员
                            this.$router.replace({name: 'auditTrail'});
                        } else {
                            API.businessHome.querySite().then(res => {
                                if (res.code == '1') {
                                    if(res.data.total === 0 ){
                                      if(data.userType === '1' && data.isSystemAdmin) {
                                        // 系统管理员 ---> 没有站点且有系统管理员权限
                                        this.$router.replace({name: 'system'});
                                      } else {
                                        // 没有站点权限
                                        this.$router.replace({name: 'notSite'});
                                      }
                                    } else {
                                        const query = this.$route.query
                                        redirectUrl ? this.$router.replace({
                                            name: redirectUrl.name,
                                            query: redirectUrl.query
                                        }) : this.$router.replace({name: 'home', query});
                                        sessionStorage.removeItem('redirectUrl')
                                    }
                                }
                            })
                        }
                    } else {
                        throw new Error(errDetails);
                    }
                } catch (e) {
                    //自动登陆失败
                    this.$router.replace({name: 'internError'}); //先写死

                    service.close();
                    console.error(e);
                } finally {
                    sessionStorage.removeItem('redirectUrl');
                }
            }
        }
    };
</script>
